import { get } from './httpClient';
import { API_BASE_URL } from '../Utils/constants';
import { getCurrentToken } from '../Access/services/authService';
import { authFetch } from './authFetch';

// El Bearer (renovado, sin `Bearer null`, reintento ante 401) lo pone `authFetch`.
const getHeaders = () => ({
  Accept: 'application/json',
});

/**
 * Obtiene los edificios (FeatureCollection GeoJSON) asociados a un lote.
 * La API devuelve todos los registros de `buildings` con ese `lot_id` (0..n features).
 * JWT. Ficha catastral — no usar en el showroom CAD.
 * @param {string} lotId
 * @returns {Promise<GeoJSON.FeatureCollection>}
 */
export const getBuildingByLotId = async (lotId) => {
  const token = getCurrentToken();
  if (!token) {
    throw new Error('getBuildingByLotId: no hay token de Cognito; el usuario debe iniciar sesión.');
  }
  const response = await authFetch(
    `${API_BASE_URL}/getbuilding?lot_id=${encodeURIComponent(lotId)}`,
    { headers: getHeaders() },
  );
  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    throw new Error(`getbuilding ${response.status}: ${detail}`);
  }
  return response.json();
};

/**
 * Edificios en una caja WGS84.
 * `GET /getbuildingsbybounds?min_lng=&min_lat=&max_lng=&max_lat=`
 *
 * Público (share anónimo, sin JWT). Con sesión manda Bearer, igual que
 * `GET /getcadproject` (restricted). No pedir el país: lado máx. 0.5°.
 * Tope 5000; la respuesta trae `returned` y `limit`. Si son iguales, cupo
 * lleno (los más cercanos al centro): no agrandar. `[]` = sin cobertura.
 * No usar `GET /getbuilding`.
 *
 * @param {{ minLng?: number, minLat?: number, maxLng?: number, maxLat?: number }|null} bounds
 * @param {{ signal?: AbortSignal }} [options]
 * @returns {Promise<object>} Envelope FeatureCollection + `_httpOk` / `_httpStatus`.
 */
export function getBuildingsByBounds(bounds, { signal } = {}) {
  const minLng = Number(bounds?.minLng);
  const minLat = Number(bounds?.minLat);
  const maxLng = Number(bounds?.maxLng);
  const maxLat = Number(bounds?.maxLat);
  if (![minLng, minLat, maxLng, maxLat].every(Number.isFinite)) {
    return Promise.resolve({
      type: 'FeatureCollection',
      features: [],
      _httpOk: false,
      _httpStatus: 400,
    });
  }
  return get('/getbuildingsbybounds', {
    params: {
      min_lng: minLng,
      min_lat: minLat,
      max_lng: maxLng,
      max_lat: maxLat,
    },
    signal,
  });
}
